import { Grid } from "@mui/material";
import SectionGrid from "components/ui/atoms/SectionGrid";
import TypographyWithMiss from "components/ui/atoms/TypographyWithMiss";
import { getCommons } from "./fieldConverterHelpers";

export const MultilineCharFieldView = ({ field, formattedValue }) => {
  let finalValue = formattedValue;
  if (typeof formattedValue === "string") {
    finalValue = (
      <ul style={{ margin: 0 }}>
        {formattedValue.split("\n").map((line, index) => (
          <li key={index}>
            {line}
            <br />
          </li>
        ))}
      </ul>
    );
  }
  return (
    <Grid container spacing={1} alignItems="center" sx={{ display: "block" }}>
      <SectionGrid
        title={field.label}
        sx={{
          display: field.hidden ? "none" : "inherit",
          textAlign: "justify",
        }}
      >
        <TypographyWithMiss
          variant="body2"
          whiteSpace="pre-line"
          isMissing={
            formattedValue === null ||
            (typeof formattedValue === "string" && formattedValue.trim() === "")
          }
        >
          {finalValue || ""}
        </TypographyWithMiss>
      </SectionGrid>
    </Grid>
  );
};

export const multilineCharFieldConverter = ({ field }) => {
  return {
    ...getCommons({ field }),
    type: "string",
    valueFormatter: field.valueFormatter,
  };
};
